import { SVGProps } from 'react';

const SvgMixer = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg viewBox='0 0 24 24' className='svg-icon' {...props}>
			<g fill='none' fillRule='evenodd'>
				<path d='M0 0h24v24H0z' />
				<path
					d='M8.423 7.196a.5.5 0 01-.133-.49l.553-2.028a1.5 1.5 0 011.334-1.101L17.799 3l1.061 1.06c1.072 1.072 2.51 2.7 4.318 4.885a2 2 0 01.273 2.117l-2.559 5.515a1.5 1.5 0 01-2.409.442L8.423 7.196zm12.12 2.025l-2.744-3.657a1.3 1.3 0 00-1.96-.14 1.5 1.5 0 000 2.122l3.182 3.182a1 1 0 001.414 0 1.153 1.153 0 00.107-1.507z'
					fill='currentColor'
				/>
				<path
					d='M10.377 14.232l1.663 1.663a1.568 1.568 0 010 2.218L8.713 21.44a1.568 1.568 0 01-2.218 0L2.06 17.004a1.568 1.568 0 010-2.218l3.327-3.327a1.568 1.568 0 012.218 0l1.664 1.664 1.663-1.664 1.11 1.11-1.664 1.663zm-3.05 5.822l3.327-3.327-.555-.554-3.326 3.326.554.555zM5.664 18.39l3.326-3.326-.554-.555-3.327 3.327.555.554zM4 16.727L7.327 13.4l-.554-.554-3.327 3.327.554.554z'
					fill='currentColor'
					opacity={0.3}
				/>
			</g>
		</svg>
	);
};

export default SvgMixer;
